import type { FaireProductEntity } from "../../entity_types/product";

export const p_maw28tmkej: FaireProductEntity = {
  token: "p_maw28tmkej",
  type: "product",
  name: "Troposa - Plus Size Boho Dress with Pockets",
  brandToken: "b_qrthtbpuwu",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/dbca052ebd32aee112f24e41cfa5d0579cc89724ee1ce9e9cbd41c623a4c26cf.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/291e216ffa6483b953d16a210e2110d8ebb307afeb84ccbf6e044a4fde200717.jpeg",
    "https://cdn.faire.com/fastly/2389da5aa8a959b43130110c9e9e8256da0102f891f444de2d37b4502f92016e.jpeg",
    "https://cdn.faire.com/fastly/1beb766b2d041eaafae962fde104b2e467029dfe5125b03823487d9bdabe3539.jpeg",
    "https://cdn.faire.com/fastly/9904d9356b05e8c14fed09f2785fe4dc683417bddb06b7fc91821e9fd492ac81.jpeg",
    "https://cdn.faire.com/fastly/5c542e846cbb9ebebe083ebc8e9e37abb6bd8cf2910297a98fe132811a11221b.jpeg",
    "https://cdn.faire.com/fastly/67f75ae46934c8d9c3287f2139d94872976f3a465e6c21fb7f267b7d63e5a303.jpeg",
    "https://cdn.faire.com/fastly/3dc071fafd1f6d8931cd548c2cac62113b5ee3f09b06feffa59238dec8e9d96f.jpeg",
    "https://cdn.faire.com/fastly/47abcc4f4df39704b4b1d9652fc99e95db56828ca49caab967a8b7036b3170d1.jpeg",
    "https://cdn.faire.com/fastly/3dc291ae368958e415ae2d0fc45db62d04956a0f0570f1469be821881d94add5.jpeg",
    "https://cdn.faire.com/fastly/04d94d5b99517919a53da5888508586dc44edcef128337616803966c7c21591a.jpeg",
  ],
  priceDollars: 34.64,
  description:
    'Stay cool and stylish in this flowy boho maxi dress designed for curvy women. The loose fit, 3/4 sleeves, and convenient side pockets combine comfort with functionality. Featuring elegant elephant prints in red or black, this dress flatters figures up to 330lbs (length: 46.5", bust: 51", hem: 52").\n\n • Breathable, lightweight fabric for summer\n • Roomy fit with comfortable 3/4 sleeves\n • Two practical side pockets\n • Beautiful elephant print pattern\n • Retail-ready packaging with UPC\n\n Size Details:\n • Length: Up to 46" (118cm)\n • Bust: Up to 51" (130cm)\n Please see the size chart for specific measurements.\n\n Perfect For: Summer vacations, Casual outings, Plus size fashion\n You May Also Like: Plus size summer dresses, Boho chic maxi dresses, Elephant print clothing',
  tags: [],
  msrpDollars: 69.28,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:02.871Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
